// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { RequestState, RowNew } from '../../../../components/Table/types';
import { flattenBurns } from '../../../../utils/flattenBurns';
import { useCustomSort } from '../../../../utils/sortByCreatedAt';
import { useGetBurnQueries } from './useGetBurnQueries';

export const useGetBurnRows = () => {
  const burnQueries = useGetBurnQueries();

  const queryDataMap = [
    { query: burnQueries.burnRequests2Step, state: RequestState.Requested },
    { query: burnQueries.executedBurns2Step, state: RequestState.Executed },
    { query: burnQueries.rejectedBurns2Step, state: RequestState.Rejected },
  ];

  const isLoading = queryDataMap.some(({ query }) => query.isLoading);

  const rows = queryDataMap.reduce((acc: RowNew[], { query, state }) => {
    const dataArray = query.data || [];

    const newRows = flattenBurns(dataArray, state);

    return acc.concat(newRows);
  }, []);
  const sortedByCreateTime = useCustomSort(rows);
  return {
    isLoading,
    rows: sortedByCreateTime,
  };
};
